import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/vercel/path0/app/layouts/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkRightSidebarSkeleton"] */ "/vercel/path0/components/work/WorkRightSidebarSkeleton.tsx");
